import { IProject } from 'pages/Projects/Projects.types';
import { getProjectsData } from 'services/api/projects';
import { IProjectsResponse } from 'types/api-responses';
import { useData } from './useData';

export const useProjectsPageData = () =>
  useData<IProjectsResponse['data']>(getProjectsData);
